<template>
  <app-layout>
    <div class="home-page">
      <div class="sc-container">
        <div class="feed-layout">

          <!-- ── Left Sidebar ── -->
          <aside class="feed-sidebar feed-sidebar--left">
            <div class="profile-card">
              <div class="profile-card__cover"></div>
              <div class="profile-card__body">
                <div class="profile-card__avatar-wrap">
                  <img
                    class="profile-card__avatar"
                    :src="$avatarSrc(user.avatar)"
                    alt=""
                    @click="showSingle($avatarSrc(user.avatar))"
                  />
                </div>
                <h3 class="profile-card__name">{{ user.name }}</h3>
                <p class="profile-card__sub" v-if="user.currentcompany">
                  {{ user.current_position }}<br />
                  <router-link :to="'/company/' + user.currentcompany.slug">{{ user.currentcompany.name }}</router-link>
                </p>
                <p class="profile-card__sub" v-else>{{ user.profession }}</p>
                <div class="profile-card__badges" v-if="user.membership || user.certification">
                  <span v-if="user.membership && user.membership.membership" class="profile-badge">
                    {{ user.membership.membership.code }}
                    <svg v-if="user.membership.status == 1" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                  <span v-if="user.certification && user.certification.certification" class="profile-badge">
                    {{ user.certification.certification.code }}
                    <svg v-if="user.certification.status == 1" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                </div>
                <div class="profile-card__stats">
                  <div class="profile-stat">
                    <strong>{{ total_project }}</strong>
                    <span>Projects</span>
                  </div>
                  <div class="profile-stat__divider"></div>
                  <div class="profile-stat">
                    <strong>{{ total_followers }}</strong>
                    <span>Followers</span>
                  </div>
                </div>
                <router-link :to="'/sc/profile/' + id" class="btn-primary profile-card__btn">View Profile</router-link>
              </div>
            </div>

            <div class="sidebar-card">
              <h4 class="sidebar-card__title">Quick Links</h4>
              <nav class="sidebar-nav">
                <router-link to="/listings" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                  Browse Listings
                </router-link>
                <router-link to="/my-Projects" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  My Projects
                </router-link>
                <router-link to="/my-followers" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  Following
                </router-link>
                <router-link to="/messages" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                  Messages
                </router-link>
              </nav>
            </div>
          </aside>

          <!-- ── Center Feed ── -->
          <main class="feed-center">

            <!-- Create card -->
            <div class="create-card">
              <div class="create-card__row">
                <div class="create-card__avatar">
                  <img v-if="user.avatar" :src="$avatarSrc(user.avatar)" alt="" />
                  <img v-else :src="initAvatar(user.name)" alt="" />
                </div>
                <button class="create-card__input" @click="showModal = true">
                  Share a project, property, or plan...
                </button>
              </div>
              <div class="create-card__actions">
                <button class="create-type-btn create-type-btn--project" @click="openModal('project')">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  Project
                </button>
                <button class="create-type-btn create-type-btn--property" @click="openModal('property')">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                  Property
                </button>
                <button class="create-type-btn create-type-btn--plan" @click="openModal('plan')">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                  Concept
                </button>
              </div>
            </div>

            <!-- Feed filter tabs -->
            <div class="feed-filter-tabs">
              <button
                v-for="tab in feedTabs"
                :key="tab.value"
                class="feed-filter-tab"
                :class="{ active: feedFilter === tab.value }"
                @click="feedFilter = tab.value"
              >{{ tab.label }}</button>
            </div>

            <!-- Feed skeleton -->
            <template v-if="feedLoading">
              <div v-for="n in 4" :key="'sk' + n" class="feed-card feed-card--skeleton">
                <div class="feed-sk__header">
                  <div class="feed-sk__avatar"></div>
                  <div class="feed-sk__meta">
                    <div class="feed-sk__line feed-sk__line--name"></div>
                    <div class="feed-sk__line feed-sk__line--time"></div>
                  </div>
                </div>
                <div class="feed-sk__img"></div>
                <div class="feed-sk__body">
                  <div class="feed-sk__line feed-sk__line--title"></div>
                  <div class="feed-sk__line feed-sk__line--title-short"></div>
                </div>
                <div class="feed-sk__actions">
                  <div class="feed-sk__action-btn"></div>
                  <div class="feed-sk__action-btn"></div>
                  <div class="feed-sk__action-btn"></div>
                </div>
              </div>
            </template>

            <!-- Feed items -->
            <template v-else-if="filteredFeeds.length">
              <div v-for="(data, index) in filteredFeeds" :key="index" class="feed-card">

                <!-- Author row -->
                <div class="feed-card__header">
                  <router-link
                    :to="data.user && data.user.company ? '/company/' + data.user.company.slug : '/sc/profile/' + (data.user ? data.user.slug : '')"
                    class="feed-card__author"
                  >
                    <img
                      v-if="data.user && data.user.avatar"
                      class="feed-card__avatar"
                      :src="$avatarSrc(data.user.avatar)"
                      alt=""
                    />
                    <img v-else class="feed-card__avatar" :src="initAvatar(data.user ? data.user.name : '')" alt="" />
                    <div>
                      <strong>{{ data.user ? data.user.name : '' }}</strong>
                      <span class="feed-card__time">{{ formatDate(data.created_at) }}</span>
                    </div>
                  </router-link>
                  <span v-if="data.type === 'project'" class="feed-badge feed-badge--project">Project</span>
                  <span v-else-if="data.type === 'property'" class="feed-badge feed-badge--property">Property</span>
                  <span v-else-if="data.type === 'plan'" class="feed-badge feed-badge--plan">Concept</span>
                  <span v-if="data.type === 'property' && data.post && data.post.is_sold" class="feed-badge feed-badge--sold">Sold</span>
                  <button
                    v-if="data.user && (data.user.id == currentUserId || data.user.owner_id == currentUserId)"
                    class="feed-delete-btn"
                    title="Delete listing"
                    @click="promptDelete(data)"
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                    </svg>
                  </button>
                </div>

                <!-- Project content -->
                <template v-if="data.type === 'project' && data.project">
                  <router-link :to="'/project/' + data.project.slug" class="feed-card__img-link" v-if="data.project.images && data.project.images.length">
                    <img class="feed-card__img" :src="data.project.images[0].path" alt="" />
                  </router-link>
                  <div class="feed-card__body">
                    <router-link :to="'/project/' + data.project.slug" class="feed-card__title">
                      {{ data.project.name.length > 80 ? data.project.name.substring(0, 80) + '...' : data.project.name }}
                    </router-link>
                  </div>
                </template>

                <!-- Property content -->
                <template v-else-if="data.type === 'property' && data.post">
                  <router-link :to="'/post/' + data.post.slug" class="feed-card__img-link" v-if="data.post.images && data.post.images.length">
                    <img class="feed-card__img" :src="data.post.images[0].path" alt="" />
                  </router-link>
                  <div class="feed-card__body">
                    <router-link :to="'/post/' + data.post.slug" class="feed-card__title">
                      {{ data.post.name.length > 80 ? data.post.name.substring(0, 80) + '...' : data.post.name }}
                    </router-link>
                  </div>
                </template>

                <!-- Plan content -->
                <template v-else-if="data.type === 'plan' && data.plan">
                  <router-link :to="'/plan/' + data.plan.slug" class="feed-card__img-link" v-if="data.plan.images && data.plan.images.length">
                    <img class="feed-card__img" :src="data.plan.images[0].path" alt="" />
                  </router-link>
                  <div class="feed-card__body">
                    <router-link :to="'/plan/' + data.plan.slug" class="feed-card__title">
                      {{ data.plan.name.length > 80 ? data.plan.name.substring(0, 80) + '...' : data.plan.name }}
                    </router-link>
                  </div>
                </template>

                <!-- Actions row -->
                <div class="feed-card__actions">
                  <button class="feed-action" @click="likeTimeline(index, data.id)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                    <span>{{ data.likes ? data.likes.length : 0 }}</span>
                  </button>
                  <button class="feed-action" @click="viewLikes(index)">
                    <span class="feed-action__label">View Likes</span>
                  </button>
                  <button class="feed-action" @click="viewComments(index)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                    <span>{{ data.comments ? data.comments.length : 0 }}</span>
                  </button>
                  <button class="feed-action feed-action--share">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                    Share
                  </button>
                </div>

                <!-- Inline comment -->
                <div class="feed-card__comment">
                  <img v-if="user.avatar" class="feed-card__comment-avatar" :src="$avatarSrc(user.avatar)" alt="" />
                  <img v-else class="feed-card__comment-avatar" :src="initAvatar(user.name)" alt="" />
                  <input
                    :id="'submitCommentButton' + data.id"
                    type="text"
                    class="feed-card__comment-input"
                    placeholder="Write a comment..."
                    @keyup.enter="sendSubmitComment(data.id)"
                  />
                </div>
              </div>

              <!-- Infinite loading -->
              <div class="infinite-wrapper">
                <infinite-loading force-use-infinite-wrapper=".infinite-wrapper" @distance="3" @infinite="fetchData2"></infinite-loading>
              </div>
            </template>

            <!-- Empty state -->
            <div v-else-if="!feedLoading && !filteredFeeds.length" class="feed-empty">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="9" x2="15" y2="9"/><line x1="9" y1="13" x2="12" y2="13"/></svg>
              <h3>Nothing in your feed yet</h3>
              <p>Follow professionals or create your first listing to get started.</p>
              <button class="btn-primary" @click="showModal = true">Create a Listing</button>
            </div>
          </main>

          <!-- ── Right Sidebar ── -->
          <aside class="feed-sidebar feed-sidebar--right">
            <div class="sidebar-card" v-if="users && users.length">
              <h4 class="sidebar-card__title">People You May Know</h4>
              <div class="people-list">
                <div v-for="u in users.slice(0, 4)" :key="u.id" class="people-item">
                  <router-link :to="'/sc/profile/' + u.slug" class="people-item__link">
                    <img
                      class="people-item__avatar"
                      :src="u.avatar ? $avatarSrc(u.avatar) : initAvatar(u.name)"
                      :alt="u.name"
                      @error="e => { e.target.src = initAvatar(u.name); }"
                    />
                    <div class="people-item__info">
                      <strong>{{ u.name }}</strong>
                      <span>{{ u.profession || 'Construction Professional' }}</span>
                    </div>
                  </router-link>
                  <button class="people-item__follow" @click="follow(u.id)">Follow</button>
                </div>
              </div>
            </div>

            <div class="sidebar-card">
              <h4 class="sidebar-card__title">Explore</h4>
              <nav class="sidebar-nav">
                <router-link to="/listings?type=project" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  Browse Projects
                </router-link>
                <router-link to="/listings?type=property" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                  Browse Properties
                </router-link>
                <router-link to="/listings?type=plan" class="sidebar-nav__link">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  Browse Concepts
                </router-link>
              </nav>
            </div>
          </aside>

        </div>
      </div>

      <!-- ── Lightbox ── -->
      <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>

      <!-- ── Delete Confirm Dialog ── -->
      <transition name="del-fade">
        <div v-if="confirmDelete.show" class="del-overlay" @click.self="cancelDeletePrompt">
          <div class="del-dialog" role="dialog" aria-modal="true">
            <div class="del-dialog__icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </div>
            <h3 class="del-dialog__title">Delete Listing?</h3>
            <p class="del-dialog__body">
              This will permanently delete
              <strong>{{ confirmDelete.item && (confirmDelete.item.project && confirmDelete.item.project.name) || (confirmDelete.item && confirmDelete.item.post && confirmDelete.item.post.name) || (confirmDelete.item && confirmDelete.item.plan && confirmDelete.item.plan.title) || 'this listing' }}</strong>.
              This action cannot be undone.
            </p>
            <div class="del-dialog__actions">
              <button class="del-btn del-btn--cancel" @click="cancelDeletePrompt" :disabled="confirmDelete.deleting">Cancel</button>
              <button class="del-btn del-btn--confirm" @click="executeDelete" :disabled="confirmDelete.deleting">
                <span v-if="confirmDelete.deleting" class="del-spinner"></span>
                <span v-else>Delete</span>
              </button>
            </div>
          </div>
        </div>
      </transition>

      <!-- ── Create Listing Modal ── -->
      <transition name="modal-fade">
        <div v-if="showModal" class="modal-overlay" @click.self="cancelForm">
          <div class="modal-panel">
            <div class="modal-panel__header">
              <h2 class="modal-panel__title">
                <template v-if="!type">New Listing</template>
                <template v-else-if="type === 'project'">New Project</template>
                <template v-else-if="type === 'property'">New Property</template>
                <template v-else-if="type === 'plan'">New Concept</template>
              </h2>
              <button class="modal-panel__close" @click="cancelForm" aria-label="Close">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div class="modal-panel__body">

              <!-- Post as selector -->
              <div v-if="myCompanies.length && !created" class="post-as-row">
                <span class="post-as-label">Post as:</span>
                <div class="post-as-options">
                  <button
                    :class="['post-as-opt', { 'post-as-opt--active': !postingAs }]"
                    @click="postingAs = null"
                  >
                    <img class="post-as-avatar" :src="user.avatar ? $avatarSrc(user.avatar) : initAvatar(user.name)" @error="$event.target.src=initAvatar(user.name)" alt="" />
                    <span>Myself</span>
                  </button>
                  <button
                    v-for="co in myCompanies"
                    :key="co.id"
                    :class="['post-as-opt', { 'post-as-opt--active': postingAs && postingAs.id === co.id }]"
                    @click="postingAs = co"
                  >
                    <img class="post-as-avatar" :src="co.avatar ? $avatarSrc(co.avatar) : initAvatar(co.name)" @error="$event.target.src=initAvatar(co.name)" alt="" />
                    <span>{{ co.name }}</span>
                  </button>
                </div>
              </div>

              <!-- Success screen -->
              <div v-if="created" class="modal-success">
                <div class="modal-success__icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                </div>
                <h3>Listing Created!</h3>
                <p>Your listing has been successfully submitted.</p>
                <button class="btn-primary" @click="closeForm">Close</button>
              </div>

              <!-- Step 1: Choose type -->
              <div v-if="!type && !created" class="type-chooser">
                <p class="type-chooser__label">What would you like to create?</p>
                <div class="type-cards">
                  <button class="type-card type-card--project" @click="type = 'project'">
                    <div class="type-card__icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    </div>
                    <strong>Project</strong>
                    <span>Construction or architecture project</span>
                  </button>
                  <button class="type-card type-card--property" @click="type = 'property'">
                    <div class="type-card__icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                    </div>
                    <strong>Property</strong>
                    <span>Real estate listing for sale or rent</span>
                  </button>
                  <button class="type-card type-card--plan" @click="type = 'plan'">
                    <div class="type-card__icon">
                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                    </div>
                    <strong>Concept</strong>
                    <span>Architectural or structural drawings</span>
                  </button>
                </div>
              </div>

              <!-- ── PROJECT FORM ── -->
              <form v-if="type === 'project' && !created" class="sc-form" novalidate>
                <div class="sc-field">
                  <label class="sc-label">Project Name <span class="req">*</span></label>
                  <input type="text" class="sc-input" v-model="project.name" placeholder="e.g. Lekki Twin Towers" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Project Description <span class="req">*</span></label>
                  <QuillEditor id="property_editor" v-model:content="project.description" contentType="html" :toolbar="customToolbar" class="sc-quill" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Project Category <span class="req">*</span></label>
                  <div class="sc-grid-3">
                    <select class="sc-select" v-model="project.project_interest_1" @change="fectchInterestChildren($event)">
                      <option value="" disabled selected>Category</option>
                      <option v-for="d in interests" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children.length" class="sc-select" v-model="project.project_interest_2" @change="fectchInterestChildren2($event)">
                      <option value="" disabled selected>Sub-category</option>
                      <option v-for="d in interest_children" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children2.length" class="sc-select" v-model="project.project_interest_3">
                      <option value="" disabled selected>Sub-category 2</option>
                      <option v-for="d in interest_children2" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="sc-grid-3">
                  <div class="sc-field">
                    <label class="sc-label">Start Date</label>
                    <input type="date" class="sc-input" v-model="project.project_start_date" />
                  </div>
                  <div class="sc-field">
                    <label class="sc-label">Status <span class="req">*</span></label>
                    <select class="sc-select" v-model="project.status">
                      <option value="" disabled selected>Select status</option>
                      <option value="1">Completed</option>
                      <option value="2">On-going</option>
                    </select>
                  </div>
                  <div class="sc-field" v-if="project.status == 1">
                    <label class="sc-label">End Date</label>
                    <input type="date" class="sc-input" v-model="project.project_end_date" />
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Project Location <span class="req">*</span></label>
                  <div class="sc-grid-3">
                    <select class="sc-select" v-model="project.country_id" @change="fetchStates($event)">
                      <option value="" disabled selected>Country</option>
                      <option v-for="d in country" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select class="sc-select" v-model="project.state_id" @change="fetchCities($event)">
                      <option value="" disabled selected>State</option>
                      <option v-for="d in state" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select class="sc-select" v-model="project.city_id">
                      <option value="" disabled selected>City</option>
                      <option v-for="d in city" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Address</label>
                  <textarea class="sc-textarea" v-model="project.address" rows="2" placeholder="Full address..."></textarea>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Height</label>
                  <select class="sc-select" v-model="project.height">
                    <option value="" disabled selected>Select height</option>
                    <option value="Low rise (Less than 3 Storeys)">Low rise (Less than 3 Storeys)</option>
                    <option value="Mid rise (4 - 10 Storeys)">Mid rise (4 - 10 Storeys)</option>
                    <option value="High rise (11 - 30 Storeys)">High rise (11 - 30 Storeys)</option>
                    <option value="Skyscrappers (above 30 storeys)">Skyscrappers (above 30 storeys)</option>
                  </select>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Client / Developer</label>
                  <multiselect v-model="project.client" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                </div>

                <!-- Architect -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Architect</label>
                    <button type="button" class="sc-add-btn" @click="addArchitectTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.architect" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.architect_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteArchitectTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Structural Engineer -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Structural Engineer</label>
                    <button type="button" class="sc-add-btn" @click="addStructuralEngineerTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.structural_engineer" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.structural_engineer_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteStructuralEngineerTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- MEP Engineer -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">MEP Engineer</label>
                    <button type="button" class="sc-add-btn" @click="addMepEngineerTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.mep_engineer" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.mep_engineer_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteMepEngineerTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Quantity Surveyor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Quantity Surveyor</label>
                    <button type="button" class="sc-add-btn" @click="addSurveyorTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.quantity_surveyor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.quantity_surveyor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteSurveyorTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Main Contractor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Main Contractor <span class="req">*</span></label>
                    <button type="button" class="sc-add-btn" @click="addMainContractorTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.main_contractor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.main_contractor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteMainContractorTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Mechanical Contractor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Mechanical Contractor</label>
                    <button type="button" class="sc-add-btn" @click="addMechanicalContractorTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.mechanical_contractor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.mechanical_contractor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteMechanicalContractorTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Electrical Contractor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Electrical Contractor</label>
                    <button type="button" class="sc-add-btn" @click="addElectricalContractorTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.electrical_contractor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.electrical_contractor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteElectricalContractorTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Piling Contractor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Piling Contractor</label>
                    <button type="button" class="sc-add-btn" @click="addPilingTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.piling_contractor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.piling_contractor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deletePilingTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Lift Contractor -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Lift Contractor</label>
                    <button type="button" class="sc-add-btn" @click="addLiftTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.lift_contractor" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.lift_contractor_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteLiftTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Project Manager -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Project Manager</label>
                    <button type="button" class="sc-add-btn" @click="addPMTeam">+ Add Team Member</button>
                  </div>
                  <multiselect v-model="project.project_manager" label="name" placeholder="Select one" :options="users" :allow-empty="true"></multiselect>
                  <div v-for="(input, idx) in project.project_manager_team" :key="idx" class="sc-team-row">
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search team member" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deletePMTeam(idx)">Remove</button>
                  </div>
                </div>

                <!-- Vendors -->
                <div class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Project Vendors</label>
                    <button type="button" class="sc-add-btn" @click="addVendor">+ Add Vendor</button>
                  </div>
                  <div v-for="(input, idx) in project.project_vendors" :key="idx" class="sc-vendor-row">
                    <model-list-select :list="vendor_category" v-model="input.vendor" option-value="id" option-text="name" placeholder="Select category" class="sc-team-select"></model-list-select>
                    <model-list-select :list="users" v-model="input.user_id" option-value="id" option-text="name" placeholder="Search vendor" class="sc-team-select"></model-list-select>
                    <button type="button" class="sc-remove-btn" @click="deleteVendor(idx)">Remove</button>
                  </div>
                </div>

                <!-- Video Links -->
                <div class="sc-field">
                  <label class="sc-label">YouTube Video URL</label>
                  <input type="url" class="sc-input" v-model="project.youtube_url" placeholder="https://www.youtube.com/watch?v=..." />
                </div>
                <div class="sc-field">
                  <label class="sc-label">Instagram Video URL</label>
                  <input type="url" class="sc-input" v-model="project.instagram_url" placeholder="https://www.instagram.com/p/..." />
                </div>

                <!-- Images -->
                <div class="sc-field">
                  <label class="sc-label">Project Images <span class="req">*</span></label>
                  <div class="sc-upload-wrap">
                    <vue-upload-multiple-image
                      @upload-success="uploadImageSuccess"
                      @before-remove="beforeRemove"
                      @edit-image="editImage"
                      @data-change="dataChange"
                      :data-images="images"
                      dragText="Drag and drop images"
                      browseText="Browse Images"
                      primaryText="added"
                      markIsPrimaryText="Set default image"
                      popupText="Description default image"
                      :maxImage="5"
                    ></vue-upload-multiple-image>
                  </div>
                </div>
              </form>

              <!-- ── PROPERTY FORM ── -->
              <form v-if="type === 'property' && !created" class="sc-form" novalidate>
                <div class="sc-field">
                  <label class="sc-label">Property Name <span class="req">*</span></label>
                  <input type="text" class="sc-input" v-model="property.name" placeholder="e.g. Victoria Island Duplex" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Property Description <span class="req">*</span></label>
                  <QuillEditor id="property_editor" v-model:content="property.description" contentType="html" :toolbar="customToolbar" class="sc-quill" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Category <span class="req">*</span></label>
                  <div class="sc-grid-3">
                    <select class="sc-select" v-model="property.project_interest_1" @change="fectchInterestChildren($event)">
                      <option value="" disabled selected>Category</option>
                      <option v-for="d in property_interests" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children.length" class="sc-select" v-model="property.project_interest_2" @change="fectchInterestChildren2($event)">
                      <option value="" disabled selected>Sub-category</option>
                      <option v-for="d in interest_children" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children2.length" class="sc-select" v-model="property.project_interest_3">
                      <option value="" disabled selected>Sub-category 2</option>
                      <option v-for="d in interest_children2" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Property Type <span class="req">*</span></label>
                  <select class="sc-select" v-model="property.type">
                    <option value="" disabled selected>Select type</option>
                    <option value="Residential">Residential</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Residential | Commercial">Residential | Commercial</option>
                  </select>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Location <span class="req">*</span></label>
                  <div class="sc-grid-3">
                    <select class="sc-select" v-model="property.country_id" @change="fetchStates($event)">
                      <option value="" disabled selected>Country</option>
                      <option v-for="d in country" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select class="sc-select" v-model="property.state_id" @change="fetchCities($event)">
                      <option value="" disabled selected>State</option>
                      <option v-for="d in state" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select class="sc-select" v-model="property.city_id">
                      <option value="" disabled selected>City</option>
                      <option v-for="d in city" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                  </div>
                  <input type="text" class="sc-input" v-model="property.address" placeholder="Street address..." style="margin-top:.5rem" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Currency</label>
                  <select class="sc-select" v-model="property.currency_id">
                    <option v-for="d in currency" :key="d.id" :value="d.id">{{ d.symbol }} - {{ d.name }}</option>
                  </select>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Pricing Type</label>
                  <div class="sc-radio-group">
                    <label class="sc-radio">
                      <input type="radio" v-model="price_type" value="single" />
                      <span>Single Price</span>
                    </label>
                    <label class="sc-radio">
                      <input type="radio" v-model="price_type" value="multiple" />
                      <span>Different Prices</span>
                    </label>
                  </div>
                </div>

                <div v-if="price_type === 'single'" class="sc-field">
                  <label class="sc-label">Property Price <span class="req">*</span></label>
                  <input type="number" class="sc-input" v-model="property.price" placeholder="0.00" />
                </div>

                <div v-if="price_type === 'multiple'" class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Property Prices <span class="req">*</span></label>
                    <button type="button" class="sc-add-btn" @click="addPrice">+ Add Price</button>
                  </div>
                  <div v-for="(input, idx) in property.prices" :key="idx" class="sc-vendor-row">
                    <div class="sc-mini-field">
                      <label class="sc-mini-label">Amount</label>
                      <input type="text" class="sc-input" v-model="input.price" placeholder="Price" onkeypress="if(isNaN(this.value+String.fromCharCode(event.keyCode)))return false;" />
                    </div>
                    <div class="sc-mini-field">
                      <label class="sc-mini-label">Title</label>
                      <input type="text" class="sc-input" v-model="input.title" placeholder="e.g. 2-bedroom unit" />
                    </div>
                    <button type="button" class="sc-remove-btn" @click="deletePrice(idx)">Remove</button>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-checkbox">
                    <input type="checkbox" v-model="more_detail" value="1" />
                    <span>Add more property details</span>
                  </label>
                </div>

                <div v-if="more_detail == '1'" class="sc-field">
                  <div class="sc-label-row">
                    <label class="sc-label">Property Details</label>
                    <button type="button" class="sc-add-btn" @click="addDetail">+ Add Detail</button>
                  </div>
                  <div v-for="(input, idx) in property.details" :key="idx" class="sc-vendor-row">
                    <div class="sc-mini-field">
                      <label class="sc-mini-label">Title</label>
                      <input type="text" class="sc-input" v-model="input.title" placeholder="e.g. Bedrooms" />
                    </div>
                    <div class="sc-mini-field">
                      <label class="sc-mini-label">Description</label>
                      <input type="text" class="sc-input" v-model="input.description" placeholder="e.g. 3" />
                    </div>
                    <button type="button" class="sc-remove-btn" @click="deleteDetail(idx)">Remove</button>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">YouTube Video URL</label>
                  <input type="url" class="sc-input" v-model="property.youtube_url" placeholder="https://www.youtube.com/watch?v=..." />
                </div>
                <div class="sc-field">
                  <label class="sc-label">Instagram Video URL</label>
                  <input type="url" class="sc-input" v-model="property.instagram_url" placeholder="https://www.instagram.com/p/..." />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Property Images <span class="req">*</span></label>
                  <div class="sc-upload-wrap">
                    <vue-upload-multiple-image
                      @upload-success="uploadImageProperty"
                      @before-remove="beforeRemove"
                      @edit-image="editImage"
                      @data-change="dataChange"
                      :data-images="images"
                      dragText="Drag and drop images"
                      browseText="Browse Images"
                      primaryText="added"
                      markIsPrimaryText="Set default image"
                      popupText="Description default image"
                      :maxImage="5"
                    ></vue-upload-multiple-image>
                  </div>
                </div>
              </form>

              <!-- ── PLAN FORM ── -->
              <form v-if="type === 'plan' && !created" class="sc-form" novalidate>
                <div class="sc-field">
                  <label class="sc-label">Title <span class="req">*</span></label>
                  <input type="text" class="sc-input" v-model="plan.title" placeholder="e.g. 4-bedroom bungalow plan" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Description <span class="req">*</span></label>
                  <QuillEditor id="plan_editor" v-model:content="plan.description" contentType="html" :toolbar="customToolbar" class="sc-quill" />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Category <span class="req">*</span></label>
                  <div class="sc-grid-3">
                    <select class="sc-select" v-model="plan.project_interest_1" @change="fectchInterestChildren($event)">
                      <option value="" disabled selected>Category</option>
                      <option v-for="d in plan_interests" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children.length" class="sc-select" v-model="plan.project_interest_2" @change="fectchInterestChildren2($event)">
                      <option value="" disabled selected>Sub-category</option>
                      <option v-for="d in interest_children" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-if="interest_children2.length" class="sc-select" v-model="plan.project_interest_3">
                      <option value="" disabled selected>Sub-category 2</option>
                      <option v-for="d in interest_children2" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Height</label>
                  <select class="sc-select" v-model="plan.height">
                    <option value="" disabled selected>Select height</option>
                    <option value="Low rise (Less than 3 Storeys)">Low rise (Less than 3 Storeys)</option>
                    <option value="Mid rise (4 - 10 Storeys)">Mid rise (4 - 10 Storeys)</option>
                    <option value="High rise (11 - 30 Storeys)">High rise (11 - 30 Storeys)</option>
                    <option value="Skyscrappers (above 30 storeys)">Skyscrappers (above 30 storeys)</option>
                  </select>
                </div>

                <div class="sc-field">
                  <label class="sc-label">Land Size <span class="req">*</span></label>
                  <div class="sc-grid-2">
                    <input type="text" class="sc-input" v-model="plan.land_size" placeholder="e.g. 500" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\..*)\./g,'$1');" />
                    <select class="sc-select" v-model="plan.land_size_unit">
                      <option value="" disabled selected>Unit</option>
                      <option value="M">m&#178;</option>
                      <option value="Plot">Plot</option>
                      <option value="Acre">Acre</option>
                      <option value="Hectares">Hectares</option>
                      <option value="KM">km&#178;</option>
                    </select>
                  </div>
                </div>

                <div class="sc-field">
                  <label class="sc-label">YouTube Video URL</label>
                  <input type="url" class="sc-input" v-model="plan.youtube_url" placeholder="https://www.youtube.com/watch?v=..." />
                </div>
                <div class="sc-field">
                  <label class="sc-label">Instagram Video URL</label>
                  <input type="url" class="sc-input" v-model="plan.instagram_url" placeholder="https://www.instagram.com/p/..." />
                </div>

                <div class="sc-field">
                  <label class="sc-label">Concept Images <span class="req">*</span></label>
                  <div class="sc-upload-wrap">
                    <vue-upload-multiple-image
                      @upload-success="uploadImagePlan"
                      @before-remove="beforeRemove"
                      @edit-image="editImage"
                      @data-change="dataChange"
                      :data-images="images"
                      dragText="Drag and drop images"
                      browseText="Browse Images"
                      primaryText="added"
                      markIsPrimaryText="Set default image"
                      popupText="Description default image"
                      :maxImage="5"
                    ></vue-upload-multiple-image>
                  </div>
                </div>
              </form>

            </div><!-- /.modal-panel__body -->

            <!-- Footer -->
            <div v-if="!created" class="modal-panel__footer">
              <button v-if="type" type="button" class="btn-outline" @click="type = ''">Back</button>
              <button type="button" class="modal-panel__cancel" @click="cancelForm">Cancel</button>
              <button v-if="type" type="button" class="btn-primary" :disabled="loading" @click="createProject">
                <span v-if="loading">Submitting...</span>
                <span v-else>Submit Listing</span>
              </button>
            </div>

          </div><!-- /.modal-panel -->
        </div><!-- /.modal-overlay -->
      </transition>

      <!-- ── Likes Modal ── -->
      <transition name="modal-fade">
        <div v-if="showLikesModal" class="modal-overlay" @click.self="showLikesModal = false">
          <div class="modal-panel modal-panel--sm">
            <div class="modal-panel__header">
              <h2 class="modal-panel__title">People who liked this</h2>
              <button class="modal-panel__close" @click="showLikesModal = false">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div class="modal-panel__body" v-if="currentData.likes">
              <div v-for="data in currentData.likes" :key="data.id" class="likes-item">
                <a :href="'/sc/profile/' + data.user.slug">
                  <img v-if="data.user.avatar" class="likes-item__avatar" :src="$avatarSrc(data.user.avatar)" alt="" />
                  <img v-else class="likes-item__avatar" :src="initAvatar(data.user.name)" alt="" />
                </a>
                <div class="likes-item__info">
                  <router-link :to="'/sc/profile/' + data.user.slug">{{ data.user.name }}</router-link>
                  <span>{{ data.user.profession }}</span>
                </div>
                <button class="people-item__follow" @click="follow(data.user.id)">Follow</button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- ── Comments Modal ── -->
      <transition name="modal-fade">
        <div v-if="showCommentsModal" class="modal-overlay" @click.self="showCommentsModal = false">
          <div class="modal-panel modal-panel--sm">
            <div class="modal-panel__header">
              <h2 class="modal-panel__title">Comments</h2>
              <button class="modal-panel__close" @click="showCommentsModal = false">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div class="modal-panel__body" v-if="currentData.comments">
              <div v-for="com in currentData.comments" :key="com.id" class="comment-item">
                <img v-if="com.user.avatar" class="comment-item__avatar" :src="$avatarSrc(com.user.avatar)" alt="" />
                <img v-else class="comment-item__avatar" :src="initAvatar(com.user.name)" alt="" />
                <div class="comment-item__bubble">
                  <div class="comment-item__meta">
                    <strong>{{ com.user.name }}</strong>
                    <span>{{ formatDate(com.created_at) }}</span>
                  </div>
                  <p>{{ com.comment }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

    </div><!-- /.home-page -->
  </app-layout>
</template>

<script>
import AppLayout from '@/layouts/AppLayout.vue';
import axios from 'axios';
import VueUploadMultipleImage from '@/components/VueUploadMultipleImage';
import moment from 'moment';
import ModelListSelect from '@/components/ModelListSelect';
import Multiselect from 'vue-multiselect';
import InfiniteLoading from 'v3-infinite-loading';
import VueEasyLightbox from 'vue-easy-lightbox';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  name: 'Feed',
  components: {
    AppLayout,
    ModelListSelect,
    Multiselect,
    VueUploadMultipleImage,
    InfiniteLoading,
    VueEasyLightbox,
    QuillEditor,
  },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Structurecity Services';
      },
    },
  },

  created() {
    this.fetchCompany();
    this.fetchUserCompanies();
    this.fetchData();
    this.fetchUsers();
    this.fetchUser();
    this.fetchCountries();
    this.fetchVendorCategory();
    this.fectchProjectInterests();
    this.fectchPropertyInterests();
    this.fectchPlanInterests();
    this.fetchProjects();
    this.fetchFollowers();
    this.fetchTotalProjects();
    this.fetchTotalFollowers();
    this.fetchCurrency();
  },

  data() {
    return {
      price_type: 'single',
      more_detail: '',
      page: 1,
      currentData: {},
      readMore: {},
      type: '',
      company: {},
      user: {},
      loading: false,
      feedLoading: true,
      created: false,
      id: localStorage.getItem('slug'),
      currentUserId: localStorage.getItem('user'),
      confirmDelete: { show: false, item: null, deleting: false },
      images: [],
      currency: [],
      country: [],
      state: [],
      city: [],
      users: [],
      projects: [],
      interests: [],
      property_interests: [],
      plan_interests: [],
      interest_children: [],
      interest_children2: [],
      vendor_category: [],
      project_client: {},
      feeds: [],
      feedFilter: '',
      feedTabs: [
        { label: 'All',        value: '' },
        { label: 'Projects',   value: 'project' },
        { label: 'Properties', value: 'property' },
        { label: 'Concepts',   value: 'plan' },
      ],
      total_project: 0,
      total_followers: 0,
      followers: [],

      myCompanies: [],
      postingAs: null,

      showModal: false,
      showLikesModal: false,
      showCommentsModal: false,

      comment: {
        description: [],
      },

      project: {
        user_id: localStorage.getItem('user'),
        name: '',
        project_interest_1: '',
        project_interest_2: '',
        project_interest_3: '',
        description: '',
        project_start_date: '',
        project_end_date: '',
        country_id: 160,
        state_id: '',
        city_id: '',
        status: '',
        height: '',
        address: '',
        architect: '',
        structural_engineer: '',
        mep_engineer: '',
        client: '',
        quantity_surveyor: '',
        main_contractor: '',
        mechanical_contractor: '',
        electrical_contractor: '',
        piling_contractor: '',
        lift_contractor: '',
        project_manager: '',
        architect_team: [],
        structural_engineer_team: [],
        mep_engineer_team: [],
        quantity_surveyor_team: [],
        main_contractor_team: [],
        mechanical_contractor_team: [],
        electrical_contractor_team: [],
        piling_contractor_team: [],
        lift_contractor_team: [],
        project_manager_team: [],
        project_vendors: [],
        youtube_url: '',
        instagram_url: '',
        images: '',
      },

      property: {
        user_id: localStorage.getItem('user'),
        name: '',
        project_interest_1: '',
        project_interest_2: '',
        project_interest_3: '',
        description: '',
        currency_id: '',
        country_id: 160,
        state_id: '',
        city_id: '',
        address: '',
        price: '',
        type: '',
        prices: [],
        details: [],
        youtube_url: '',
        instagram_url: '',
        images: '',
      },

      plan: {
        user_id: localStorage.getItem('user'),
        title: '',
        project_interest_1: '',
        project_interest_2: '',
        project_interest_3: '',
        description: '',
        height: '',
        land_size: '',
        land_size_unit: '',
        youtube_url: '',
        instagram_url: '',
        images: '',
      },

      imgs: '',
      visible: false,
      index: 0,

      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
    };
  },

  methods: {
    nameColor(name) {
      const palette = ['#4f46e5','#0891b2','#059669','#d97706','#7c3aed','#db2777','#ea580c','#0284c7'];
      let h = 0;
      for (const c of (name || '')) h = (h * 31 + c.charCodeAt(0)) & 0xffffffff;
      return palette[Math.abs(h) % palette.length];
    },
    initAvatar(name) {
      const initials = (name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
      const bg = this.nameColor(name);
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="${bg}"/><text x="18" y="23" font-family="Arial,sans-serif" font-size="13" font-weight="700" fill="#fff" text-anchor="middle">${initials}</text></svg>`;
      return 'data:image/svg+xml;base64,' + btoa(svg);
    },

    logout() {
      localStorage.clear();
      this.$router.go();
    },

    openModal(t) {
      this.type = t;
      this.showModal = true;
    },

    fetchData() {
      this.feedLoading = true;
      axios(process.env.VUE_APP_API_URL + 'user/feeds/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) {
            return (this.errorMessage = 'Could not fetch data');
          }
          this.feeds = response.data.data;
          this.page = this.page + 1;
          this.fetchNigeriaStates();
          this.fetchLagosCities();
        })
        .catch(() => {})
        .finally(() => { this.feedLoading = false; });
    },

    fetchData2($state) {
      axios(process.env.VUE_APP_API_URL + 'user/feeds/' + localStorage.getItem('user') + '?page=' + this.page)
        .then(res => {
          if (res.data && res.data.data) {
            res.data.data.forEach(value => this.feeds.push(value));
          }
          $state.loaded();
          this.page = this.page + 1;
          if (!res.data.data || res.data.data.length <= 0) {
            $state.complete();
          }
        })
        .catch(() => { $state.complete(); });
    },

    fetchCompany() {
      axios(process.env.VUE_APP_API_URL + 'company')
        .then(response => {
          if (response.status !== 200) return;
          this.company = response.data;
        })
        .catch(() => {});
    },

    fetchUserCompanies() {
      const userId = localStorage.getItem('user');
      if (!userId) return;
      axios(process.env.VUE_APP_API_URL + 'user/get-companies/' + userId)
        .then(res => {
          if (res.data && res.data.data) this.myCompanies = res.data.data;
        })
        .catch(() => {});
    },

    fetchCurrency() {
      axios(process.env.VUE_APP_API_URL + 'currency')
        .then(response => {
          if (response.status !== 200) return;
          this.currency = response.data;
        })
        .catch(() => {});
    },

    fetchUser() {
      axios(process.env.VUE_APP_API_URL + 'user/details/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) return;
          this.user = response.data;
        })
        .catch(() => {});
    },

    fetchCountries() {
      axios(process.env.VUE_APP_API_URL + 'country')
        .then(response => {
          if (response.status !== 200) return;
          this.country = response.data;
        })
        .catch(() => {});
    },

    fetchStates(e) {
      axios(process.env.VUE_APP_API_URL + 'state/' + e.target.value)
        .then(response => {
          if (response.status !== 200) return;
          this.state = response.data;
        })
        .catch(() => {});
    },

    fetchCities(e) {
      axios(process.env.VUE_APP_API_URL + 'city/' + e.target.value)
        .then(response => {
          if (response.status !== 200) return;
          this.city = response.data;
        })
        .catch(() => {});
    },

    fetchNigeriaStates() {
      axios(process.env.VUE_APP_API_URL + 'state/160')
        .then(response => {
          if (response.status !== 200) return;
          this.state = response.data;
        })
        .catch(() => {});
    },

    fetchLagosCities() {
      axios(process.env.VUE_APP_API_URL + 'city/2671')
        .then(response => {
          if (response.status !== 200) return;
          this.city = response.data;
        })
        .catch(() => {});
    },

    fetchUsers() {
      axios(process.env.VUE_APP_API_URL + 'users')
        .then(response => {
          if (response.status !== 200) return;
          this.users = response.data;
        })
        .catch(() => {});
    },

    fetchVendorCategory() {
      axios(process.env.VUE_APP_API_URL + 'vendor-category')
        .then(response => {
          if (response.status !== 200) return;
          this.vendor_category = response.data;
        })
        .catch(() => {});
    },

    fectchProjectInterests() {
      axios(process.env.VUE_APP_API_URL + 'project-interest')
        .then(response => {
          if (response.status !== 200) return;
          this.interests = response.data;
        })
        .catch(() => {});
    },

    fectchPropertyInterests() {
      axios(process.env.VUE_APP_API_URL + 'property-interest')
        .then(response => {
          if (response.status !== 200) return;
          this.property_interests = response.data;
        })
        .catch(() => {});
    },

    fectchPlanInterests() {
      axios(process.env.VUE_APP_API_URL + 'plan-interest')
        .then(response => {
          if (response.status !== 200) return;
          this.plan_interests = response.data;
        })
        .catch(() => {});
    },

    fectchInterestChildren(e) {
      axios(process.env.VUE_APP_API_URL + 'interest/' + e.target.value)
        .then(response => {
          if (response.status !== 200) return;
          this.interest_children = response.data;
        })
        .catch(() => {});
    },

    fectchInterestChildren2(e) {
      axios(process.env.VUE_APP_API_URL + 'interest/' + e.target.value)
        .then(response => {
          if (response.status !== 200) return;
          this.interest_children2 = response.data;
        })
        .catch(() => {});
    },

    fetchProjects() {
      axios(process.env.VUE_APP_API_URL + 'project/user/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) return;
          this.projects = response.data;
        })
        .catch(() => {});
    },

    fetchFollowers() {
      axios(process.env.VUE_APP_API_URL + 'user/following/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) return;
          this.followers = response.data;
        })
        .catch(() => {});
    },

    fetchTotalProjects() {
      axios(process.env.VUE_APP_API_URL + 'project/total-project/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) return;
          this.total_project = response.data;
        })
        .catch(() => {});
    },

    fetchTotalFollowers() {
      axios(process.env.VUE_APP_API_URL + 'user/total-followers/' + localStorage.getItem('user'))
        .then(response => {
          if (response.status !== 200) return;
          this.total_followers = response.data;
        })
        .catch(() => {});
    },

    createProject() {
      const postUserId = this.postingAs ? this.postingAs.id : localStorage.getItem('user');
      this.loading = true;
      if (this.type === 'project') {
        axios.post(process.env.VUE_APP_API_URL + 'project/create', { ...this.project, user_id: postUserId })
          .then(response => {
            if (response.status === 200) {
              this.created = true;
              this.type = '';
              this.images = [];
              this._resetProject();
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(() => { this.loading = false; });
      } else if (this.type === 'property') {
        axios.post(process.env.VUE_APP_API_URL + 'property/create', { ...this.property, user_id: postUserId })
          .then(response => {
            if (response.status === 200) {
              this.created = true;
              this.type = '';
              this.images = [];
              this._resetProperty();
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(() => { this.loading = false; });
      } else if (this.type === 'plan') {
        axios.post(process.env.VUE_APP_API_URL + 'plan/create', { ...this.plan, user_id: postUserId })
          .then(response => {
            if (response.status === 200) {
              this.created = true;
              this.type = '';
              this.images = [];
              this._resetPlan();
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(() => { this.loading = false; });
      }
    },

    _resetProject() {
      this.project.name = '';
      this.project.description = '';
      this.project.project_start_date = '';
      this.project.project_end_date = '';
      this.project.country_id = '';
      this.project.state_id = '';
      this.project.city_id = '';
      this.project.status = '';
      this.project.height = '';
      this.project.address = '';
      this.project.architect = '';
      this.project.structural_engineer = '';
      this.project.mep_engineer = '';
      this.project.client = '';
      this.project.quantity_surveyor = '';
      this.project.main_contractor = '';
      this.project.mechanical_contractor = '';
      this.project.electrical_contractor = '';
      this.project.piling_contractor = '';
      this.project.lift_contractor = '';
      this.project.project_manager = '';
      this.project.architect_team = [];
      this.project.structural_engineer_team = [];
      this.project.mep_engineer_team = [];
      this.project.quantity_surveyor_team = [];
      this.project.main_contractor_team = [];
      this.project.mechanical_contractor_team = [];
      this.project.electrical_contractor_team = [];
      this.project.piling_contractor_team = [];
      this.project.lift_contractor_team = [];
      this.project.project_manager_team = [];
      this.project.project_vendors = [];
      this.project.images = '';
    },

    _resetProperty() {
      this.property.name = '';
      this.property.description = '';
      this.property.country_id = '';
      this.property.state_id = '';
      this.property.city_id = '';
      this.property.address = '';
      this.property.type = '';
      this.property.prices = [];
      this.property.details = [];
      this.property.images = '';
    },

    _resetPlan() {
      this.plan.title = '';
      this.plan.description = '';
      this.plan.land_size = '';
      this.plan.land_size_unit = '';
      this.plan.height = '';
      this.plan.images = '';
    },

    cancelForm() {
      if (this.type && !confirm('Are you sure you want to discard this form?')) return;
      this.showModal = false;
      this.type = '';
      this.postingAs = null;
      this.images = [];
      this._resetProject();
      this._resetProperty();
    },

    closeForm() {
      this.created = false;
      this.showModal = false;
      this.type = '';
      this.postingAs = null;
      this.images = [];
      this._resetProject();
      this._resetProperty();
      this._resetPlan();
      this.fetchData();
    },

    submitComment(event, id) {
      this.loading = true;
      axios.post(process.env.VUE_APP_API_URL + 'timeline/comment', {
        comment: event.target.value,
        timeline_id: id,
        user_id: localStorage.getItem('user'),
      })
        .then(response => {
          if (response.status === 200) {
            this.comment.description = [];
            window.Fire.emit('action');
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => { this.loading = false; });
    },

    likeTimeline(index, id) {
      this.loading = true;
      axios.post(process.env.VUE_APP_API_URL + 'timeline/like', {
        timeline_id: id,
        user_id: localStorage.getItem('user'),
      })
        .then(response => {
          if (response.status === 200) {
            window.Fire.emit('action2');
          }
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },

    promptDelete(item) {
      this.confirmDelete = { show: true, item, deleting: false };
    },

    cancelDeletePrompt() {
      if (this.confirmDelete.deleting) return;
      this.confirmDelete.show = false;
    },

    executeDelete() {
      const item = this.confirmDelete.item;
      if (!item) return;
      let endpoint = '';
      let itemId = null;
      if (item.type === 'project' && item.project) {
        endpoint = 'project/delete/' + item.project.id;
        itemId = item.project.id;
      } else if (item.type === 'property' && item.post) {
        endpoint = 'property/delete/' + item.post.id;
        itemId = item.post.id;
      } else if (item.type === 'plan' && item.plan) {
        endpoint = 'plan/delete/' + item.plan.id;
        itemId = item.plan.id;
      }
      if (!endpoint) return;
      this.confirmDelete.deleting = true;
      axios.delete(process.env.VUE_APP_API_URL + endpoint)
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            const idx = this.feeds.findIndex(f => f.id === item.id);
            if (idx !== -1) this.feeds.splice(idx, 1);
            this.$toastr.s('Listing deleted.');
          } else {
            this.$toastr.e(res.message || 'Could not delete listing.');
          }
          this.confirmDelete = { show: false, item: null, deleting: false };
        })
        .catch(() => {
          this.$toastr.e('Could not delete listing.');
          this.confirmDelete.deleting = false;
        });
    },

    follow(id) {
      this.loading = true;
      axios.post(process.env.VUE_APP_API_URL + 'user/follow', {
        user_id: id,
        followed_by: localStorage.getItem('user'),
      })
        .then(response => {
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },

    addArchitectTeam() { this.project.architect_team.push({ user_id: '' }); },
    deleteArchitectTeam(index) { this.project.architect_team.splice(index, 1); },
    addStructuralEngineerTeam() { this.project.structural_engineer_team.push({ user_id: '' }); },
    deleteStructuralEngineerTeam(index) { this.project.structural_engineer_team.splice(index, 1); },
    addMepEngineerTeam() { this.project.mep_engineer_team.push({ user_id: '' }); },
    deleteMepEngineerTeam(index) { this.project.mep_engineer_team.splice(index, 1); },
    addSurveyorTeam() { this.project.quantity_surveyor_team.push({ user_id: '' }); },
    deleteSurveyorTeam(index) { this.project.quantity_surveyor_team.splice(index, 1); },
    addMainContractorTeam() { this.project.main_contractor_team.push({ user_id: '' }); },
    deleteMainContractorTeam(index) { this.project.main_contractor_team.splice(index, 1); },
    addMechanicalContractorTeam() { this.project.mechanical_contractor_team.push({ user_id: '' }); },
    deleteMechanicalContractorTeam(index) { this.project.mechanical_contractor_team.splice(index, 1); },
    addElectricalContractorTeam() { this.project.electrical_contractor_team.push({ user_id: '' }); },
    deleteElectricalContractorTeam(index) { this.project.electrical_contractor_team.splice(index, 1); },
    addPilingTeam() { this.project.piling_contractor_team.push({ user_id: '' }); },
    deletePilingTeam(index) { this.project.piling_contractor_team.splice(index, 1); },
    addLiftTeam() { this.project.lift_contractor_team.push({ user_id: '' }); },
    deleteLiftTeam(index) { this.project.lift_contractor_team.splice(index, 1); },
    addPMTeam() { this.project.project_manager_team.push({ user_id: '' }); },
    deletePMTeam(index) { this.project.project_manager_team.splice(index, 1); },
    addVendor() { this.project.project_vendors.push({ vendor: '', user_id: '' }); },
    deleteVendor(index) { this.project.project_vendors.splice(index, 1); },
    addPrice() { this.property.prices.push({ title: '', price: '' }); },
    deletePrice(index) { this.property.prices.splice(index, 1); },
    addDetail() { this.property.details.push({ title: '', description: '' }); },
    deleteDetail(index) { this.property.details.splice(index, 1); },

    uploadImageSuccess(formData, index, fileList) { this.project.images = fileList; },
    uploadImageProperty(formData, index, fileList) { this.property.images = fileList; },
    uploadImagePlan(formData, index, fileList) { this.plan.images = fileList; },

    beforeRemove(index, done, fileList) {
      if (confirm('Remove image?')) done();
    },
    editImage(formData, index, fileList) {},
    dataChange(data) {},

    formatDate(date) { return moment(date).fromNow(); },

    newline() { this.comment.description = `${this.comment.description}\n`; },

    viewLikes(index) {
      this.currentData = this.feeds[index];
      this.showLikesModal = true;
    },

    viewComments(index) {
      this.currentData = this.feeds[index];
      this.showCommentsModal = true;
    },

    showMore(id) { this.$set(this.readMore, id, true); },
    showLess(id) { this.$set(this.readMore, id, false); },

    sendSubmitComment(id) {
      const el = document.getElementById('submitCommentButton' + id);
      if (el && el.value) this.submitComment2(el.value, id);
    },

    submitComment2(comment, id) {
      this.loading = true;
      axios.post(process.env.VUE_APP_API_URL + 'timeline/comment', {
        comment: comment,
        timeline_id: id,
        user_id: localStorage.getItem('user'),
      })
        .then(response => {
          if (response.status === 200) {
            this.comment.description = [];
            window.Fire.emit('action');
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => { this.loading = false; });
    },

    showSingle(data) {
      this.imgs = data;
      this.visible = true;
    },

    handleHide() { this.visible = false; },
  },

  mounted() {
    window.Fire.on('action', () => { this.fetchData(); });
    window.Fire.on('action2', () => { this.fetchData(); });
  },

  computed: {
    image_url() { return process.env.VUE_APP_IMAGE_URL; },
    filteredFeeds() {
      if (!this.feedFilter) return this.feeds;
      return this.feeds.filter(f => f.type === this.feedFilter);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* ── Page shell ── */
.home-page { padding: 0; }

/* ── 3-column layout ── */
.feed-layout {
  display: grid;
  grid-template-columns: 260px 1fr 260px;
  gap: 1.5rem;
  padding: 2rem 0;
  align-items: start;
}

/* ── Sidebars ── */
.feed-sidebar { display: flex; flex-direction: column; gap: 1rem; }

/* ── Profile card ── */
.profile-card {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  overflow: hidden;
}
.profile-card__cover {
  height: 60px;
  background: linear-gradient(135deg, var(--primary) 0%, #2d5a8e 100%);
}
.profile-card__body {
  padding: 0 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.profile-card__avatar-wrap {
  margin-top: -36px;
  margin-bottom: .75rem;
}
.profile-card__avatar {
  width: 72px; height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--surface);
  box-shadow: var(--shadow);
  cursor: pointer;
  transition: transform .2s;
}
.profile-card__avatar:hover { transform: scale(1.05); }
.profile-card__name {
  font-size: 1rem; font-weight: 700;
  color: var(--text); margin-bottom: .25rem;
}
.profile-card__sub {
  font-size: .8125rem; color: var(--text-muted);
  margin-bottom: .625rem; line-height: 1.45;
}
.profile-card__sub a { color: var(--primary); text-decoration: none; }
.profile-card__sub a:hover { text-decoration: underline; }
.profile-card__badges {
  display: flex; gap: .375rem; margin-bottom: .75rem; flex-wrap: wrap; justify-content: center;
}
.profile-badge {
  display: inline-flex; align-items: center; gap: .2rem;
  font-size: .75rem; font-weight: 600; color: var(--primary);
  background: rgba(30,58,95,.08);
  padding: .2rem .6rem; border-radius: var(--radius-full);
}
.profile-card__stats {
  display: flex; align-items: center; width: 100%;
  background: var(--surface-2); border-radius: var(--radius);
  margin-bottom: 1rem; overflow: hidden;
}
.profile-stat {
  flex: 1; padding: .625rem; text-align: center;
}
.profile-stat strong { display: block; font-size: 1.125rem; font-weight: 700; color: var(--text); }
.profile-stat span { font-size: .75rem; color: var(--text-muted); }
.profile-stat__divider { width: 1px; background: var(--border); align-self: stretch; margin: .375rem 0; }
.profile-card__btn {
  display: block; width: 100%; text-align: center;
  text-decoration: none; padding: .5rem 1rem;
  font-size: .875rem;
}

/* ── Sidebar card ── */
.sidebar-card {
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1rem;
}
.sidebar-card__title {
  font-size: .8125rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: .06em; color: var(--text-muted);
  margin-bottom: .75rem;
}
.sidebar-nav { display: flex; flex-direction: column; gap: .125rem; }
.sidebar-nav__link {
  display: flex; align-items: center; gap: .625rem;
  padding: .5rem .625rem; border-radius: .5rem;
  font-size: .875rem; font-weight: 500;
  color: var(--text-muted); text-decoration: none;
  transition: background .15s, color .15s;
}
.sidebar-nav__link:hover,
.sidebar-nav__link.router-link-active {
  background: var(--surface-2); color: var(--primary); text-decoration: none;
}
.sidebar-nav__link svg { flex-shrink: 0; }

/* ── People list ── */
.people-list { display: flex; flex-direction: column; gap: .75rem; }
.people-item { display: flex; align-items: center; gap: .625rem; }
.people-item__link { display: flex; align-items: center; gap: .625rem; flex: 1; text-decoration: none; min-width: 0; }
.people-item__avatar {
  width: 36px; height: 36px; border-radius: 50%; object-fit: cover; flex-shrink: 0;
}
.people-item__info { min-width: 0; }
.people-item__info strong { display: block; font-size: .8125rem; font-weight: 600; color: var(--text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.people-item__info span { font-size: .75rem; color: var(--text-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; }
.people-item__follow {
  padding: .3rem .75rem; border-radius: var(--radius-full);
  border: 1.5px solid var(--primary); background: none;
  font-size: .75rem; font-weight: 600; color: var(--primary);
  cursor: pointer; transition: background .15s, color .15s; flex-shrink: 0;
}
.people-item__follow:hover { background: var(--primary); color: #fff; }

/* ── Create card ── */
.create-card {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
}
.create-card__row {
  display: flex; align-items: center; gap: .75rem; margin-bottom: .875rem;
}
.create-card__avatar {
  width: 40px; height: 40px; border-radius: 50%; overflow: hidden; flex-shrink: 0;
}
.create-card__avatar img { width: 100%; height: 100%; object-fit: cover; }
.create-card__input {
  flex: 1; text-align: left;
  border: 1.5px solid var(--border); background: var(--surface-2);
  border-radius: var(--radius-full); padding: .5rem 1rem;
  font-size: .9rem; color: var(--text-muted);
  cursor: pointer; transition: border-color .15s, background .15s;
}
.create-card__input:hover { border-color: var(--primary); background: var(--surface); }
.create-card__actions {
  display: flex; gap: .5rem; border-top: 1px solid var(--border-light); padding-top: .75rem;
}
.create-type-btn {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: .375rem;
  padding: .5rem; border-radius: .625rem; border: 1.5px solid transparent;
  font-size: .8125rem; font-weight: 600; cursor: pointer;
  transition: background .15s, border-color .15s, color .15s;
  background: none;
}
.create-type-btn--project { color: var(--primary); border-color: rgba(30,58,95,.15); }
.create-type-btn--project:hover { background: rgba(30,58,95,.07); border-color: var(--primary); }
.create-type-btn--property { color: var(--success); border-color: rgba(16,185,129,.15); }
.create-type-btn--property:hover { background: rgba(16,185,129,.07); border-color: var(--success); }
.create-type-btn--plan { color: var(--accent); border-color: rgba(245,158,11,.15); }
.create-type-btn--plan:hover { background: rgba(245,158,11,.07); border-color: var(--accent); }

/* ── Feed card ── */
/* ── Feed skeleton ── */
@keyframes feed-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.feed-sk__avatar,
.feed-sk__line,
.feed-sk__img,
.feed-sk__action-btn {
  background: linear-gradient(90deg, #f0f0f0 25%, #e5e5e5 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: feed-shimmer 1.4s infinite;
  border-radius: 4px;
}
.feed-card--skeleton { pointer-events: none; }
.feed-sk__header { display: flex; align-items: center; gap: .75rem; padding: 1rem 1rem .75rem; }
.feed-sk__avatar { width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0; }
.feed-sk__meta { flex: 1; display: flex; flex-direction: column; gap: .4rem; }
.feed-sk__line--name  { height: 13px; width: 45%; }
.feed-sk__line--time  { height: 11px; width: 28%; }
.feed-sk__img { height: 220px; margin: 0; border-radius: 0; }
.feed-sk__body { padding: .875rem 1rem .25rem; display: flex; flex-direction: column; gap: .5rem; }
.feed-sk__line--title       { height: 14px; width: 90%; }
.feed-sk__line--title-short { height: 14px; width: 65%; }
.feed-sk__actions { display: flex; gap: .75rem; padding: .75rem 1rem 1rem; }
.feed-sk__action-btn { height: 28px; width: 60px; border-radius: 999px; }

.feed-card {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  margin-bottom: 1rem;
  overflow: hidden;
}
.feed-card__header {
  display: flex; align-items: center; gap: .75rem;
  padding: .875rem 1rem .5rem;
}
.feed-card__author {
  display: flex; align-items: center; gap: .625rem; flex: 1;
  text-decoration: none; color: var(--text); min-width: 0;
}
.feed-card__author strong { display: block; font-size: .9rem; font-weight: 600; color: var(--text); }
.feed-card__author:hover strong { color: var(--primary); }
.feed-card__avatar { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.feed-card__time { display: block; font-size: .75rem; color: var(--text-muted); }
.feed-badge {
  font-size: .7rem; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
  padding: .2rem .6rem; border-radius: var(--radius-full); flex-shrink: 0;
}
.feed-badge--project { background: rgba(30,58,95,.1); color: var(--primary); }
.feed-badge--property { background: rgba(16,185,129,.1); color: var(--success); }
.feed-badge--plan { background: rgba(245,158,11,.1); color: #d97706; }
.feed-badge--sold { background: #fee2e2; color: #dc2626; font-weight: 700; }
.feed-card__img-link { display: block; }
.feed-card__img { width: 100%; max-height: 320px; object-fit: cover; }
.feed-card__body { padding: .75rem 1rem .25rem; }
.feed-card__title {
  display: block; font-size: 1rem; font-weight: 600; color: var(--text);
  text-decoration: none; line-height: 1.4;
}
.feed-card__title:hover { color: var(--primary); text-decoration: none; }

.feed-card__actions {
  display: flex; align-items: center; gap: .25rem;
  padding: .5rem 1rem; border-top: 1px solid var(--border-light); margin-top: .5rem;
}
.feed-action {
  display: flex; align-items: center; gap: .375rem;
  padding: .4rem .75rem; border-radius: .5rem; border: none; background: none;
  font-size: .8125rem; color: var(--text-muted); cursor: pointer;
  transition: background .15s, color .15s; font-weight: 500;
}
.feed-action:hover { background: var(--surface-2); color: var(--primary); }
.feed-action--share { margin-left: auto; }
.feed-action__label { font-size: .8125rem; }

.feed-card__comment {
  display: flex; align-items: center; gap: .625rem;
  padding: .625rem 1rem; border-top: 1px solid var(--border-light);
}
.feed-card__comment-avatar { width: 30px; height: 30px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.feed-card__comment-input {
  flex: 1; border: 1.5px solid var(--border); background: var(--surface-2);
  border-radius: var(--radius-full); padding: .4rem .875rem;
  font-size: .8125rem; color: var(--text);
  transition: border-color .15s;
  font-family: inherit;
}
.feed-card__comment-input:focus { border-color: var(--primary); background: var(--surface); outline: none; }

/* ── Feed filter tabs ── */
.feed-filter-tabs {
  display: flex; gap: 4px;
  background: var(--surface); border-radius: var(--radius-lg);
  box-shadow: var(--shadow); padding: 8px 12px;
  margin-bottom: 12px;
}
.feed-filter-tab {
  padding: 7px 16px; border-radius: 7px; border: none;
  font-size: .85rem; font-weight: 500; cursor: pointer;
  background: transparent; color: var(--text-muted, #6b7280);
  transition: background .15s, color .15s;
}
.feed-filter-tab:hover { background: #f3f4f6; color: var(--text, #111827); }
.feed-filter-tab.active {
  background: var(--primary, #1e3a5f); color: #fff; font-weight: 600;
}

/* ── Empty state ── */
.feed-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 4rem 2rem; text-align: center;
  background: var(--surface); border-radius: var(--radius-lg); box-shadow: var(--shadow);
  color: var(--text-muted);
}
.feed-empty svg { margin-bottom: 1.25rem; opacity: .35; }
.feed-empty h3 { font-size: 1.125rem; font-weight: 700; color: var(--text); margin-bottom: .375rem; }
.feed-empty p { margin-bottom: 1.5rem; }

/* ── Modal overlay ── */
.modal-overlay {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: flex-start; justify-content: center;
  padding: 2rem 1rem; overflow-y: auto;
}
.modal-panel {
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  width: 100%; max-width: 680px;
  display: flex; flex-direction: column;
  max-height: calc(100vh - 4rem);
  margin: auto;
  overflow: hidden;
}
.modal-panel--sm { max-width: 480px; }

.modal-panel__header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.modal-panel__title { font-size: 1.125rem; font-weight: 700; color: var(--text); margin: 0; }
.modal-panel__close {
  width: 32px; height: 32px; border-radius: 50%; border: none; background: none;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: var(--text-muted); transition: background .15s;
}
.modal-panel__close:hover { background: var(--surface-3); color: var(--text); }

.modal-panel__body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
}

.modal-panel__footer {
  display: flex; align-items: center; justify-content: flex-end; gap: .75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--surface-2);
}
.modal-panel__cancel {
  padding: .5rem 1.25rem; border-radius: var(--radius-full);
  border: 1.5px solid var(--border); background: none;
  font-size: .875rem; font-weight: 600; color: var(--text-muted);
  cursor: pointer; transition: border-color .15s, color .15s;
}
.modal-panel__cancel:hover { border-color: var(--text); color: var(--text); }

/* ── Success state ── */
.modal-success {
  display: flex; flex-direction: column; align-items: center;
  padding: 2rem; text-align: center;
}
.modal-success__icon {
  width: 80px; height: 80px; border-radius: 50%;
  background: rgba(16,185,129,.1);
  display: flex; align-items: center; justify-content: center;
  color: var(--success); margin-bottom: 1.25rem;
}
.modal-success h3 { font-size: 1.25rem; font-weight: 700; color: var(--text); margin-bottom: .5rem; }
.modal-success p { color: var(--text-muted); margin-bottom: 1.5rem; }

/* ── Post as selector ── */
.post-as-row {
  display: flex; align-items: center; gap: 1rem;
  padding: .75rem 1rem; background: var(--surface); border-radius: var(--radius);
  border: 1px solid var(--border-light); flex-wrap: wrap;
}
.post-as-label { font-size: .8125rem; font-weight: 600; color: var(--text-muted); white-space: nowrap; }
.post-as-options { display: flex; flex-wrap: wrap; gap: .5rem; }
.post-as-opt {
  display: flex; align-items: center; gap: .5rem;
  padding: .3125rem .75rem .3125rem .375rem; border-radius: 999px;
  border: 2px solid var(--border); background: var(--surface-2);
  cursor: pointer; transition: border-color .15s, background .15s;
  font-size: .8125rem; font-weight: 500; color: var(--text);
}
.post-as-opt:hover { border-color: var(--primary); }
.post-as-opt--active { border-color: var(--primary); background: rgba(30,58,95,.07); color: var(--primary); }
.post-as-avatar { width: 24px; height: 24px; border-radius: 50%; object-fit: cover; }

/* ── Type chooser ── */
.type-chooser { }
.type-chooser__label { font-size: .9375rem; font-weight: 600; color: var(--text); margin-bottom: 1rem; }
.type-cards {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: .875rem;
}
.type-card {
  display: flex; flex-direction: column; align-items: center; text-align: center;
  padding: 1.5rem 1rem; border-radius: var(--radius);
  border: 2px solid var(--border); background: var(--surface);
  cursor: pointer; transition: border-color .2s, box-shadow .2s, transform .15s;
  gap: .5rem;
}
.type-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-2px); }
.type-card--project:hover { border-color: var(--primary); }
.type-card--property:hover { border-color: var(--success); }
.type-card--plan:hover { border-color: var(--accent); }
.type-card__icon {
  width: 52px; height: 52px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: .25rem;
}
.type-card--project .type-card__icon { background: rgba(30,58,95,.08); color: var(--primary); }
.type-card--property .type-card__icon { background: rgba(16,185,129,.08); color: var(--success); }
.type-card--plan .type-card__icon { background: rgba(245,158,11,.08); color: var(--accent); }
.type-card strong { font-size: .9375rem; font-weight: 700; color: var(--text); }
.type-card span { font-size: .8125rem; color: var(--text-muted); line-height: 1.4; }

/* ── Form elements ── */
.sc-form { display: flex; flex-direction: column; gap: 1.125rem; }
.sc-field { display: flex; flex-direction: column; gap: .375rem; }
.sc-label { font-size: .875rem; font-weight: 600; color: var(--text); }
.sc-label-row { display: flex; align-items: center; justify-content: space-between; gap: .5rem; }
.req { color: var(--danger); }

.sc-input {
  width: 100%; padding: .5625rem .875rem;
  border: 1.5px solid var(--border); border-radius: .5rem;
  font-size: .9rem; color: var(--text); background: var(--surface);
  font-family: inherit; transition: border-color .15s, box-shadow .15s;
  box-sizing: border-box;
}
.sc-input:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgba(30,58,95,.08); outline: none; }

.sc-select {
  width: 100%; padding: .5625rem .875rem;
  border: 1.5px solid var(--border); border-radius: .5rem;
  font-size: .9rem; color: var(--text); background: var(--surface);
  font-family: inherit; cursor: pointer;
  transition: border-color .15s;
  box-sizing: border-box;
}
.sc-select:focus { border-color: var(--primary); outline: none; }

.sc-textarea {
  width: 100%; padding: .5625rem .875rem;
  border: 1.5px solid var(--border); border-radius: .5rem;
  font-size: .9rem; color: var(--text); background: var(--surface);
  font-family: inherit; resize: vertical;
  transition: border-color .15s;
  box-sizing: border-box;
}
.sc-textarea:focus { border-color: var(--primary); outline: none; }

.sc-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: .625rem; }
.sc-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: .625rem; }

.sc-quill { border-radius: .5rem; overflow: hidden; }
:deep(.ql-editor) { min-height: 160px; }

.sc-team-row {
  display: flex; align-items: center; gap: .5rem; margin-top: .5rem;
}
.sc-team-select { flex: 1; }
.sc-vendor-row {
  display: flex; align-items: flex-end; gap: .5rem; margin-top: .5rem; flex-wrap: wrap;
}
.sc-mini-field { flex: 1; display: flex; flex-direction: column; gap: .2rem; min-width: 120px; }
.sc-mini-label { font-size: .75rem; font-weight: 600; color: var(--text-muted); }

.sc-add-btn {
  font-size: .75rem; font-weight: 600; color: var(--primary);
  background: none; border: none; cursor: pointer; padding: .1rem .25rem;
  text-decoration: underline; white-space: nowrap;
}
.sc-add-btn:hover { color: var(--accent); }
.sc-remove-btn {
  font-size: .75rem; font-weight: 600; color: var(--danger);
  background: none; border: 1px solid var(--danger);
  border-radius: .375rem; padding: .3rem .625rem;
  cursor: pointer; white-space: nowrap; flex-shrink: 0;
  transition: background .15s, color .15s;
}
.sc-remove-btn:hover { background: var(--danger); color: #fff; }

.sc-upload-wrap { border: 2px dashed var(--border); border-radius: var(--radius); padding: .5rem; }

.sc-radio-group { display: flex; gap: 1.25rem; }
.sc-radio { display: flex; align-items: center; gap: .375rem; cursor: pointer; font-size: .875rem; color: var(--text); }
.sc-radio input { accent-color: var(--primary); }
.sc-checkbox { display: flex; align-items: center; gap: .375rem; cursor: pointer; font-size: .875rem; color: var(--text); }
.sc-checkbox input { accent-color: var(--primary); }

/* ── Likes modal ── */
.likes-item {
  display: flex; align-items: center; gap: .75rem;
  padding: .75rem 0; border-bottom: 1px solid var(--border-light);
}
.likes-item:last-child { border-bottom: none; }
.likes-item__avatar { width: 44px; height: 44px; border-radius: 50%; object-fit: cover; }
.likes-item__info { flex: 1; min-width: 0; }
.likes-item__info a { display: block; font-weight: 600; font-size: .9rem; color: var(--text); text-decoration: none; }
.likes-item__info a:hover { color: var(--primary); }
.likes-item__info span { font-size: .8125rem; color: var(--text-muted); }

/* ── Comments modal ── */
.comment-item {
  display: flex; align-items: flex-start; gap: .75rem;
  padding: .75rem 0; border-bottom: 1px solid var(--border-light);
}
.comment-item:last-child { border-bottom: none; }
.comment-item__avatar { width: 36px; height: 36px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.comment-item__bubble {
  flex: 1; background: var(--surface-2); border-radius: .75rem; padding: .625rem .875rem;
}
.comment-item__meta { display: flex; align-items: center; justify-content: space-between; margin-bottom: .25rem; }
.comment-item__meta strong { font-size: .875rem; font-weight: 600; color: var(--text); }
.comment-item__meta span { font-size: .75rem; color: var(--text-muted); }
.comment-item__bubble p { font-size: .875rem; color: var(--text); margin: 0; }

/* ── Modal transition ── */
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity .2s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity: 0; }

/* ── Responsive ── */
@media (max-width: 1100px) {
  .feed-layout { grid-template-columns: 220px 1fr 220px; }
}
@media (max-width: 900px) {
  .feed-layout {
    grid-template-columns: 1fr;
    padding: 1rem 0;
  }
  .feed-sidebar--left { order: -1; }
  .feed-sidebar--right { display: none; }
  .type-cards { grid-template-columns: 1fr; }
  .sc-grid-3 { grid-template-columns: 1fr; }
}
@media (max-width: 600px) {
  .create-card__actions { flex-wrap: wrap; }
  .create-type-btn { min-width: calc(50% - .25rem); }
  .modal-panel { max-height: 100vh; border-radius: 0; }
  .modal-overlay { padding: 0; align-items: flex-end; }
}

/* ── Delete button ── */
.feed-delete-btn {
  margin-left: auto;
  display: flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border-radius: 50%;
  border: none; background: none; cursor: pointer;
  color: var(--text-muted);
  transition: background .15s, color .15s;
  flex-shrink: 0;
}
.feed-delete-btn:hover { background: #fee2e2; color: #dc2626; }

/* ── Delete confirm dialog ── */
.del-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,.45);
  display: flex; align-items: center; justify-content: center;
  padding: 1rem;
}
.del-dialog {
  background: var(--surface, #fff);
  border-radius: 1rem;
  box-shadow: 0 20px 60px rgba(0,0,0,.2);
  padding: 2rem 1.75rem 1.5rem;
  width: 100%; max-width: 380px;
  text-align: center;
  animation: del-pop .18s ease;
}
@keyframes del-pop {
  from { opacity: 0; transform: scale(.93); }
  to   { opacity: 1; transform: scale(1); }
}
.del-dialog__icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 60px; height: 60px; border-radius: 50%;
  background: #fee2e2; color: #dc2626;
  margin-bottom: 1rem;
}
.del-dialog__title {
  font-size: 1.125rem; font-weight: 700;
  color: var(--text, #111); margin: 0 0 .5rem;
}
.del-dialog__body {
  font-size: .9rem; color: var(--text-muted, #6b7280);
  line-height: 1.5; margin: 0 0 1.5rem;
}
.del-dialog__body strong { color: var(--text, #111); }
.del-dialog__actions { display: flex; gap: .75rem; justify-content: center; }
.del-btn {
  flex: 1; padding: .6rem 1rem; border-radius: .625rem;
  font-size: .9rem; font-weight: 600; cursor: pointer;
  border: none; transition: background .15s, opacity .15s;
}
.del-btn:disabled { opacity: .6; cursor: not-allowed; }
.del-btn--cancel {
  background: var(--surface-2, #f3f4f6); color: var(--text, #111);
}
.del-btn--cancel:hover:not(:disabled) { background: var(--border-light, #e5e7eb); }
.del-btn--confirm {
  background: #dc2626; color: #fff;
  display: flex; align-items: center; justify-content: center; gap: .5rem;
}
.del-btn--confirm:hover:not(:disabled) { background: #b91c1c; }
.del-spinner {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,.4);
  border-top-color: #fff;
  animation: spin .6s linear infinite;
  display: inline-block;
}
.del-fade-enter-active, .del-fade-leave-active { transition: opacity .18s; }
.del-fade-enter-from, .del-fade-leave-to { opacity: 0; }
</style>
